/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

export interface LanguageSelectorSignature {
  Args: {
    availableLanguages: string[];
    changeLanguage: (language: string) => void;
    language: string;
  };
  Blocks: {
    default: [];
  };
  Element: null;
}

export default class LanguageSelectorComponent extends Component<LanguageSelectorSignature> {
  formatLanguage = (language: string) => language.split('-')[0];

  @action
  updateLanguage(language: unknown) {
    this.args.changeLanguage(language as string);
  }
}
